// Author liang gang qiang
// Date 2023-12-13 10:13:13

import * as model from "@/model/emAssistant/jsc/JscConfigurationModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.JscConfiguration(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EMASSISTANT_JSC_URL,
    })
    .buildStore()
